export default __webpack_public_path__ + "static/media/ic_aave_24.4fc56820.svg";